import { Box, Card, Typography } from '@mui/material';
import usePatient from 'store/patient/usePatient';

const Allergy = () => {
  const { patientInfo } = usePatient();

  const toList = (v?: string | null) =>
    (v ?? '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

  const drug = toList(patientInfo?.allergy_drug);
  const food = toList(patientInfo?.allergy_food);
  const env = toList(patientInfo?.allergy_environmental);

  const Section = ({ title, items }: { title: string; items: string[] }) => (
    <>
      <Typography sx={{ mt: 1, mb: 1, fontWeight: 600, fontSize: 12 }}>
        {title}
      </Typography>
      <Box component="ul" sx={{ pl: 4, m: 0 }}>
        {items.length ? (
          items.map((it, idx) => (
            <Typography
              component="li"
              key={`${title}-${idx}`}
              sx={{ fontSize: 14 }}
            >
              {it}
            </Typography>
          ))
        ) : (
          <Typography
            component="li"
            sx={{ color: 'text.disabled', fontSize: 14 }}
          >
            None
          </Typography>
        )}
      </Box>
    </>
  );

  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      overflow="auto"
      sx={{ border: '1px solid #cdcdcd', borderRadius: 1, mb: 1.5 }}
    >
      <Card
        component="section"
        sx={{ p: '12px 16px', height: '100%', overflow: 'auto' }}
      >
        <Typography sx={{ fontWeight: 800, mb: 1, fontSize: 15 }}>
          Allergy
        </Typography>
        <Section title="Drug" items={drug} />
        <Section title="Food" items={food} />
        <Section title="Environmental" items={env} />
      </Card>
    </Box>
  );
};

export default Allergy;
